import React from "react";
import { useNavigate, Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ArrowLeft } from "lucide-react";
import AppShell from "@/components/AppShell";

export default function Privacy() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  return (
    <AppShell>
      <div className="md:max-w-2xl md:mx-auto">
      <div className="px-5 pt-1 flex items-center gap-3" data-testid="privacy-page">
        <button
          onClick={() => navigate(-1)}
          aria-label={t("common.back")}
          data-testid="privacy-back"
          className="w-9 h-9 rounded-full bg-white border border-[#E8E5DF] flex items-center justify-center text-leaf-ink"
        >
          <ArrowLeft className="w-4 h-4" strokeWidth={1.5} />
        </button>
        <h1 className="font-display text-3xl text-leaf-ink leading-tight">{t("privacy.title")}</h1>
      </div>

      <div className="px-5 mt-6 space-y-5 pb-2 text-leaf-ink leading-relaxed">
        <p className="text-xs uppercase tracking-[0.18em] text-leaf-mist">{t("privacy.lastUpdated")}</p>
        <Section title={t("privacy.collectTitle")}>{t("privacy.collect")}</Section>
        <Section title={t("privacy.useTitle")}>{t("privacy.use")}</Section>
        <Section title={t("privacy.aiTitle")}>{t("privacy.ai")}</Section>
        <Section title={t("privacy.storageTitle")}>{t("privacy.storage")}</Section>
        <Section title={t("privacy.cookiesTitle")}>{t("privacy.cookies")}</Section>
        <Section title={t("privacy.childrenTitle")}>{t("privacy.children")}</Section>
        <Section title={t("privacy.rightsTitle")}>{t("privacy.rights")}</Section>
        <Section title={t("privacy.contactTitle")}>
          {t("privacy.contact")} <Link to="/terms" className="text-leaf underline">{t("login.terms")}</Link>
        </Section>
      </div>
      </div>
    </AppShell>
  );
}

const Section = ({ title, children }) => (
  <section className="bg-white rounded-3xl border border-[#E8E5DF] p-5">
    <h2 className="text-xs uppercase tracking-[0.18em] font-medium text-leaf">{title}</h2>
    <div className="mt-3"><p>{children}</p></div>
  </section>
);
